import type { LastError } from '#common/types/a-form'

export default defineStore('useRetrieveAccountStore', () => {
  const { t } = useI18n()
  const route = useRoute()

  const retrieveFormState = ref({
    email: '',
  })

  const sendNewWebsiteMailHandler = () => {
    return $fetch('/api/users/send-new-website-mail-with-email', {
      body: {
        email: retrieveFormState.value.email,
        redirect: route.query.redirect,
      },
      method: 'POST',
    })
  }

  const shouldSendNewWebsiteMail = async (email: string) => {
    return await $fetch('/api/users/should-send-new-website-mail', {
      body: {
        email,
      },
      method: 'POST',
    })
  }

  const retrieveAccountOnLoginError = async (
    email: string,
    lastError: Ref<LastError>,
  ) => {
    try {
      await shouldSendNewWebsiteMail(email)
    }
    catch {
      return
    }

    lastError.value = {
      color: 'purple',
      data: [],
      message: t('components.stores.useRetrieveAccountStore.lastError.message'),
      status: 422,
      statusText: '',
    }

    retrieveFormState.value.email = email
    await sendNewWebsiteMailHandler()
    retrieveFormState.value.email = ''
  }

  return {
    retrieveAccountOnLoginError,
    retrieveFormState,
    sendNewWebsiteMailHandler,
    shouldSendNewWebsiteMail,
  }
})
